import React from 'react';
import './login.css';
import systemLogo from '../../../assests/icons/system_icon.png';
import AdminHeader from '../common/header/header';
import AdminFooter from '../common/footer/footer';

type AdminAuthShellProps = {
  children: React.ReactNode;
  userName?: string;
  onLogout?: () => void;
};

/** Shared cream page + green title used by login, forgot-password, and change-password. */
const AdminAuthShell: React.FC<AdminAuthShellProps> = ({ children, userName, onLogout }) => {
  return (
    <div className="admin-login">
      <AdminHeader userName={userName} onLogout={onLogout} />
      <div className="admin-login__content">
        <div className="admin-login__card">
          <div className="admin-login__logo-wrap">
            <img
              src={systemLogo}
              alt=""
              className="admin-login__logo"
              aria-hidden
            />
            <h1 className="admin-login__title">書類+</h1>
          </div>
          <hr className="admin-login__divider" />
          {children}
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminAuthShell;
